import { Form } from '@mairistem/composants';

import { formatMonetaire } from '@/utils';

interface CarteBancaireProps {
  numero: string;
  montant: number;
}

const CarteBancaire = (props: CarteBancaireProps) => {
  const { numero: numeroProps, montant: montantProps } = props;

  return (
    <Form.Group style={{ margin: 0, flex: 1 }}>
      <Form.Field inline width={2}>
        <label>Carte bancaire</label>
      </Form.Field>
      <Form.Field inline width={2}>
        N° du ticket
        {' : '}
        <label>{numeroProps}</label>
      </Form.Field>
      <Form.Field
        inline
        width={12}
        // @ts-expect-error
        style={{ textAlign: 'right' }}
      >
        Montant
        {' : '}
        <label>{formatMonetaire(montantProps, 2)}</label>
      </Form.Field>
    </Form.Group>
  );
};

export default CarteBancaire;
